import React from 'react';
import useOnScreen from '../../hooks/useOnScreen';

export interface ToastComboProps {
	toast: JSX.Element;
	embeddedMessage: JSX.Element;
	renderEmbeddedMessage: boolean;
	messageRef: React.MutableRefObject<any>;
	hideToast?: boolean;
}
export function ToastCombo(props: ToastComboProps) {
	const { toast, embeddedMessage, renderEmbeddedMessage, messageRef, hideToast } = props;

	const messageVisible = useOnScreen(messageRef);

	if (!renderEmbeddedMessage) return null;

	return (
		<>
			{embeddedMessage}
			{(!messageVisible && !hideToast) && toast}
		</>
	);

}

ToastCombo.defaultProps = {
	hideToast: false,
};